.notFound {
  margin-left: 40px;
  font-size: 18px;
}

.homeButton {
  margin-top: 40px;
  font-size: 18px;
  padding: 15px;
  border-radius: 5px;
}
